export enum DataExchangeRoleDto {
  Sender = 0,
  Receiver = 1
}
